// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Env = require("./reason/common/Env.bs.js");
let AuthSession = require("./utils/AuthSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let RelayRuntime = require("relay-runtime");
let GraphQLWSClient = require("./GraphQLWSClient.bs.js");
let Stdlib_Nullable = require("@rescript/runtime/lib/js/Stdlib_Nullable.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let Primitive_exceptions = require("@rescript/runtime/lib/js/Primitive_exceptions.js");

let Graphql_error = /* @__PURE__ */Primitive_exceptions.create("RelayEnv.Graphql_error");

async function fetchQuery(operation, variables, _cacheConfig, _uploadables) {
  let match = operation.text;
  if (match === null) {
    return Object.fromEntries([[
        "data",
        Object.fromEntries([])
      ]]);
  }
  let token = await AuthSession.getWithExpiryCheck(operation.name);
  let headers = Stdlib_Array.keepSome([
    [
      "content-type",
      "application/json"
    ],
    [
      "accept",
      "application/json"
    ],
    token !== undefined ? [
        "Authorization",
        `Bearer ` + token
      ] : undefined
  ]);
  let resp = await fetch(Env.apiPath + `/graphql`, {
    method: "POST",
    body: Primitive_option.some(JSON.stringify(Object.fromEntries([
      [
        "query",
        Stdlib_Nullable.getOr(operation.text, "")
      ],
      [
        "variables",
        variables
      ],
      [
        "operationName",
        operation.name
      ]
    ]))),
    headers: Primitive_option.some(new Headers(headers))
  });
  if (resp.ok) {
    return await resp.json();
  }
  throw {
    RE_EXN_ID: Graphql_error,
    _1: "Request failed: " + resp.statusText,
    Error: new Error()
  };
}

let network = RelayRuntime.Network.create(fetchQuery, Primitive_option.toUndefined(Stdlib_Option.map(GraphQLWSClient.client, wsClient => ((operation, variables, _cacheConfig) => {
  let subscriptionQuery_operationName = operation.name;
  let subscriptionQuery_query = Stdlib_Nullable.getOr(operation.text, "");
  let subscriptionQuery = {
    operationName: subscriptionQuery_operationName,
    query: subscriptionQuery_query,
    variables: variables
  };
  return RelayRuntime.Observable.create(sink => {
    let unsubscribe = wsClient.subscribe(subscriptionQuery, sink);
    return {
      unsubscribe: unsubscribe,
      closed: false
    };
  });
}))));

let environment = RescriptRelay.Environment.make(network, RescriptRelay.Store.make(new RelayRuntime.RecordSource(), 10, undefined), (nodeObj, param) => nodeObj.nodeId, undefined, undefined, undefined, undefined);

exports.environment = environment;
/* network Not a pure module */
